import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CmgSelect',
})
export default class CmgSelect extends Vue {
    isExpanded = false;
    selectedOption = { formatted: '', value: '' };
    selectedOptionIndex = -1;
    arrowCounter = 0;

    @Prop({ required: true, type: Array })
    options!: any[];

    @Prop({ required: false, type: String })
    label?: string;

    @Prop({ required: true, type: String })
    placeholder!: string;

    @Prop({ required: true, type: Boolean })
    shouldShowPlaceholder!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    shouldHighlightSelectedOption?: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    hasError?: boolean;
    
    @Prop({ required: false, default: false, type: Boolean })
    unmaskLabel?: boolean;

    onSelectOption(option: { value: string, formatted: string }, index: number) {
        this.selectedOption = option;
        this.selectedOptionIndex = index;
        this.$emit('change', option.value);
        this.arrowCounter = 0;
        this.isExpanded = false;
    }

    onBlur() {
        this.isExpanded = false;
        this.$emit('blur');
    }

    onFocus() {
        this.$emit('focus');
    }

    onSelectPlaceholder() {
        this.selectedOption = { formatted: '', value: '' };
        this.selectedOptionIndex = -1;
        this.$emit('change', null);
    }

    selectPickupTime() {
        if (this.isExpanded) {
            Vue.nextTick(() => {
                setTimeout(() => {
                    const focusNearby = document.getElementsByClassName('option pickuptime')[this.arrowCounter] as HTMLElement;
                    if (focusNearby) {
                        focusNearby.focus();
                    }
                });
            });
        }
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
        this.selectPickupTime();
    }

    onArrowDown(event: any) {
        event.preventDefault();
        if (this.arrowCounter < this.options.length - 1) {
            this.arrowCounter = this.arrowCounter + 1;
            this.selectPickupTime();
        }
    }

    onArrowUp(event: any) {
        event.preventDefault();
        if (this.arrowCounter > 0) {
            this.arrowCounter = this.arrowCounter - 1;
            this.selectPickupTime();
        }
    }
}
